var editScript = `<script>
const inputGroupFields = document.querySelectorAll('.input_field_group input');
const selectGroupFields = document.querySelectorAll('.input_field_group select');
inputGroupFields.forEach(input => {
  if(input.value !== '') {
    input.classList.add(ON_FOCUS);
  } 

  input.addEventListener('focusin', (e) => {
    e.target.classList.add(ON_FOCUS)
  })
  input.addEventListener('change', (e) => {
    if(e.target.value !== ''){
      e.target.classList.add(ON_FOCUS);
    } 
  });
  input.addEventListener('focusout', (e) => {
    if(e.target.value === '') {
      e.target.classList.remove(ON_FOCUS)
    } 
  })
})

selectGroupFields.forEach(select => {
  if(select.value !== '') {
    select.classList.add(ON_FOCUS);
  } 

  select.addEventListener('focusin', (e) => {
    e.target.classList.add(ON_FOCUS)
  })
  select.addEventListener('focusout', (e) => {
    if(e.target.value === '') {
      e.target.classList.remove(ON_FOCUS)
    } 
  })
  select.addEventListener('change', (e) => {
    if(e.target.value === ''){
      e.target.classList.remove(ON_FOCUS);
    } 
  });
})
</script>`;
  const ON_FOCUS = 'onfocus';
  const accountClosePanel = document.querySelector('#account-close-panel');
  const accountAddressPanel = document.querySelector('#account-address-panel');
  const accountOpenPanel = document.querySelector('#open-account-address');
  const accountOpenPanel2 = document.querySelector('#open-account-address2');
  accountClosePanel.addEventListener('click', () => {
    accountAddressPanel.querySelector('.content').classList.remove('open-panel');
    accountAddressPanel.querySelector('.content').classList.add('close-panel');
    setTimeout(() => {
        accountAddressPanel.classList.remove('account-address-panel')
        accountAddressPanel.classList.add('account-address-panel-close')
        accountAddressPanel.querySelector('#account-close-panel').classList.add('d-none')
        accountAddressPanel.querySelector('#form').classList.add('d-none');
        document.body.classList.remove('overflow__hidden')
    }, 500);
  });

  const openAccountPanels = document.querySelectorAll('#open-account-address, #open-account-address2');
  openAccountPanels.forEach(panel => {
    panel.addEventListener('click', () => {
      accountAddressPanel.classList.remove('account-address-panel-close')
      accountAddressPanel.classList.add('account-address-panel')
      accountAddressPanel.querySelector('.content').classList.add('open-panel');
      accountAddressPanel.querySelector('.content').classList.remove('close-panel');
      accountAddressPanel.querySelector('#account-close-panel').classList.remove('d-none')
      accountAddressPanel.querySelector('#form').classList.remove('d-none');
      document.body.classList.add('overflow__hidden')
    });
  });

  const openAddressEdit = document.querySelectorAll('.open-account-address-edit');
  const accountAddressEditPanel = document.querySelector('#account-address-edit-panel');
  const accountAddressEditClosePanel = document.querySelector('#account-address-edit-close-panel');
  openAddressEdit.forEach(el => {
    el.addEventListener('click', (e) => {
      let editaddressid = e.target.getAttribute("edit-form-id");
      let getEditInner = document.querySelector(`#form_${editaddressid}`).innerHTML;

      const accountEditInner = document.querySelector('#account-edit-inner');
      accountEditInner.innerHTML = '';
      accountEditInner.insertAdjacentHTML("beforeend", getEditInner);
      accountEditInner.insertAdjacentHTML("beforeend", editScript);
      accountAddressEditPanel.classList.remove('account-address-edit-panel-close');
      accountAddressEditPanel.classList.add('account-address-edit-panel');
      accountAddressEditPanel.querySelector('.content').classList.add('open-panel');
      accountAddressEditPanel.querySelector('.content').classList.remove('close-panel');
      accountAddressEditPanel.querySelector('#account-address-edit-close-panel').classList.remove('d-none');
      accountAddressEditPanel.querySelector('#form').classList.remove('d-none');
      document.body.classList.add('overflow__hidden');
      new Shopify.CountryProvinceSelector(`AddressCountry_${editaddressid}`, `AddressProvince_${editaddressid}`, {
        hideElement: `AddressProvinceContainer_${editaddressid}`
      });
    })
  })

  accountAddressEditClosePanel.addEventListener('click', () => {
    accountAddressEditPanel.querySelector('.content').classList.remove('open-panel');
    accountAddressEditPanel.querySelector('.content').classList.add('close-panel');
    setTimeout(() => {
        accountAddressEditPanel.classList.remove('account-address-edit-panel')
        accountAddressEditPanel.classList.add('account-address-panel-close')
        accountAddressEditPanel.querySelector('#account-address-edit-close-panel').classList.add('d-none')
        accountAddressEditPanel.querySelector('#form').classList.add('d-none');
        document.body.classList.remove('overflow__hidden')
    }, 500);
  });

document.addEventListener('click', event => {
  const panelAddressEdit = document.querySelector('.account-address-edit-panel');
  if(panelAddressEdit == event.target) {
    accountAddressEditClosePanel.click();
  }

  const panelAddress = document.querySelector('.account-address-panel')
  if(panelAddress == event.target) {
    accountClosePanel.click();
  }
})

window.addEventListener('DOMContentLoaded', () => {
  const countryDropdownForNew = document.getElementById("AddressCountryNew");
  if(countryDropdownForNew) {
    countryDropdownForNew.classList.add('onfocus');
  }

  if (Shopify && Shopify.CountryProvinceSelector) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  const inputGroupFields = document.querySelectorAll('.input_field_group input');
  const selectGroupFields = document.querySelectorAll('.input_field_group select');
  inputGroupFields.forEach(input => {
    if(input.value !== '') {
      input.classList.add(ON_FOCUS);
    }

    input.addEventListener('focusin', (e) => {
      e.target.classList.add(ON_FOCUS)
    })
    input.addEventListener('change', (e) => {
      if(e.target.value !== ''){
        e.target.classList.add(ON_FOCUS);
      }
    });
    input.addEventListener('focusout', (e) => {
      if(e.target.value === '') {
        e.target.classList.remove(ON_FOCUS)
      }
    })
  })

  selectGroupFields.forEach(select => {
    if(select.value !== '') {
      select.classList.add(ON_FOCUS);
    }

    select.addEventListener('focusin', (e) => {
      e.target.classList.add(ON_FOCUS)
    })
    select.addEventListener('focusout', (e) => {
      if(e.target.value === '' || e.target.value === '---') {
        e.target.classList.remove(ON_FOCUS)
      }
    })
    select.addEventListener('change', (e) => {
      if(e.target.value === ''){
        e.target.classList.remove(ON_FOCUS);
      }
    });
  })
})
